import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js";

type PositionType = 'left' | 'right' | 'top' | 'bottom' | 'chartArea';
const CircularProgressbar = (props: any) => {
  const chartRef = useRef<Chart | null>(null);
  const [data, setData] = useState([])
  const [backgroundColor, setBackgroundColor] = useState([])
  const [cutoutPercentage, setCutoutPercentage] = useState(60)
  const [legendPosition, setLegendPosition] = useState<PositionType>('left');
  useEffect(() => {
    props.data && setData(props.data);
    props.backgroundColor && setBackgroundColor(props.backgroundColor)
    props.cutoutPercentage<=0 && setCutoutPercentage(props.cutoutPercentage)
    if (props.legendPosition !== undefined) {
      setLegendPosition(props.legendPosition);
    }
  }, [props.data]);


  const horizontalCanvas = (canvas: HTMLCanvasElement | null) => {
    if (!canvas) return;
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    const ctx = canvas.getContext("2d");
    if (ctx) {
      chartRef.current = new Chart(ctx, {
        type: "pie",
        data: {
          labels: props.labels,
          datasets: [
            {
              data: data,
              backgroundColor: backgroundColor,
            },
          ],
        },
        options: {
          responsive: true,
          layout: {},
          cutoutPercentage: cutoutPercentage,
          legend: {
            display: true ,
            position: legendPosition,
          },
          title: {
            display: false,
            text: 'Chart.js Doughnut Chart'
          },
          scales: {
            yAxes: [{
              ticks: {
                display: false
              },
              gridLines: {
                display: false
              },
              scaleLabel: {
                display: false,
                labelString: "Amount"
              }
            }],
            xAxes: [{
              ticks: {
                display: false
              },
              gridLines: {
                display: false
              },
            }]
          },
        },
      });
    }
  };
  return (
    <>
      <canvas ref={horizontalCanvas} height={props.height ? props.height : ""} width={props.width ? props.width : ""}></canvas>
    </>
  );
};
export default CircularProgressbar;
